<!--
 * @Description: 审核。审核状态获取与提交不一致，需要做特殊处理
                 服务商与供应商都可以审核，订单类型不一样审核方不一样，此处都交给返回数据处理
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :disabled="disabled"
    :model="formData"
    :rules="formRules"
  >
    <div class="form-dialog__title">
      <h1>审核操作</h1>
    </div>
    <div class="form-dialog__content" style="display: block">
      <BaseFormItem label="审核" prop="invoiceStatus">
        <BaseRadioGroup
          v-model="formData.invoiceStatus"
          @change="onRadioChange"
        >
          <BaseRadio
            v-for="item in Object.values(INVOICE_AUDIT_TYPE)"
            :key="item.value"
            :value="item.value"
          >
            {{ invoiceFunction === 1 ? '蓝字' : '红字' }}{{ item.label }}
          </BaseRadio>
        </BaseRadioGroup>
      </BaseFormItem>
      <BaseFormItem
        label="驳回原因"
        prop="noPassReason"
        v-if="formData.invoiceStatus === 0"
      >
        <BaseInput
          class="form-dialog__w280"
          type="textarea"
          placeholder="请输入"
          show-word-limit
          :rows="4"
          :maxlength="120"
          v-model="formData.noPassReason"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseRadioGroup,
  BaseRadio,
  BaseInput
} from 'xrk-components';
import { DetailType, InvoiceFunction } from '@V/invoice/src/types';
import { INVOICE_AUDIT_TYPE } from '@V/invoice/src/constants';
import { AuditInvoiceParams } from '@V/invoice/src/data-source/types';

const props = withDefaults(
  defineProps<{
    detailType: DetailType;
    invoiceFunction?: InvoiceFunction; // 1蓝票 2红票
  }>(),
  { invoiceFunction: 1 }
);

const disabled = props.detailType !== 10;
const formRef = ref(null);
const formData = defineModel<AuditInvoiceParams>();
const formRules = {
  invoiceStatus: [
    {
      required: true,
      trigger: 'change',
      message: '请选择审核结果'
    }
  ],
  noPassReason: [
    {
      required: true,
      trigger: 'change',
      message: '请填写驳回原因'
    }
  ]
};

const onRadioChange = v => {
  if (v) {
    formData.value.noPassReason = '';
  }
};

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
